@import (reference) '../../../constants/spacing.module.less';

.empty-row {
  align-items: center;
  justify-content: center;
  gap: @space-16;
  padding: @space-24;
}

.store-settings-link {
  color: var(--primary--link--text-color--2);
}
